
import { SQL_COURSES, SQL_ADVANCED_PHASE_COURSES } from './sql';
import { SQL_PHASE1_COURSES } from './sql/phase1';
import { PYTHON_COURSES } from './python';
import { AI_COURSES } from './ai';
import { JAVA_COURSES } from './java';
import { DOTNET_COURSES } from './dotnet';
import { CSHARP_COURSES } from './csharp';
import { UNITY_GAME_DEVELOPMENT, UNREAL_GAME_DEVELOPMENT, AR_VR_DEVELOPMENT, DESKTOP_APPLICATION_DEVELOPMENT } from './game-development';
import { UI_UX_COURSES } from './ui-ux-design';
import { GRAPHICS_PROGRAMMING_COURSES } from './graphics-programming';
import { COURSES as REACT_COURSES } from './courses/index';
import { AWS_COURSES } from './aws';
import { JAVASCRIPT_COURSES } from './javascript';
import { ML_COURSES } from './ml';
import { DATASCIENCE_COURSES } from './datascience';
import { DATAENGINEERING_COURSES } from './dataengineering';
import { GCP_COURSES } from './gcp';
import { POWERBI_COURSES } from './powerbi';
import { TABLEAU_COURSES } from './tableau';
import { DEVOPS_COURSES } from './devops';
import { APPSEC_COURSES } from './appsec';
import { MOBILE_COURSES } from './mobile';
import { BACKEND_COURSES } from './backend'; 
import { DATABASE_COURSES } from './database';
import { AZURE_COURSES } from './azure';
import { SECURITY_COURSES } from './security';
import { BLOCKCHAIN_COURSES } from './blockchain';
import { ENTERPRISE_TRAINING_COURSES } from './enterprise-training';
import { PROFESSIONAL_DEVELOPMENT_COURSES } from './professional-development';
import { ETL_COURSES } from './etl';
// New course categories integration
import { RUST_COURSES } from './rust';
import { MODERN_FRONTEND_COURSES } from './modern-frontend';
import { KUBERNETES_MASTERY_COURSES } from './kubernetes-mastery';
import { EDGE_COMPUTING_COURSES } from './edge-computing';
import { CROSS_PLATFORM_COURSES } from './cross-platform';
import { GREEN_TECH_COURSES } from './green-tech';
import { NO_CODE_COURSES } from './no-code';
import { ADVANCED_API_COURSES } from './advanced-api';

export interface CourseOverview {
  id: string;
  title: string;
  description: string;
  level: string;
  totalDuration: string;
  image: string;
  prerequisites: string[];
  learningOutcomes: string[];
  type: 'sql' | 'python' | 'ai' | 'java' | 'dotnet' | 'csharp' | 'react' | 'aws' | 'javascript' | 'ml' | 'datascience' | 'dataengineering' | 'gcp' | 'powerbi' | 'tableau' | 'azure' | 'devops' | 'appsec' | 'mobile' | 'backend' | 'database' | 'security' | 'blockchain' | 'enterprise-training' | 'professional-development' | 'game-development' | 'ui-ux' | 'graphics' | 'etl' | 'rust' | 'modern-frontend' | 'kubernetes-mastery' | 'edge-computing' | 'cross-platform' | 'green-tech' | 'no-code' | 'advanced-api';
}

export interface Course {
  id: string;
  title: string;
  description: string;
  level: string;
  totalDuration?: string; // Optional for compatibility with existing course types
  image: string;
  prerequisites: string[];
  learningOutcomes: string[];
  modules: any[];
  type: string; // Required type property
  courseType?: string; // Optional for backward compatibility
}

// Helper function to normalize course data
const normalizeCourse = (course: any, type: string): Course => {
  console.log('Normalizing course:', course.id, 'type:', type);
  
  return {
    id: course.id,
    title: course.title,
    description: course.description,
    level: course.level,
    totalDuration: course.totalDuration || course.duration || 'Not specified',
    image: course.image || course.imageSrc || '/api/placeholder/400/300',
    prerequisites: course.prerequisites || course.requirements || [],
    learningOutcomes: course.learningOutcomes || [],
    modules: course.modules || [],
    type: type,
    courseType: type || 'general' // Provide courseType when available
  };
};

export const getAllCourses = (): Course[] => {
  console.log('🔄 Loading all courses...');
  
  const allCourses = [
    // SQL Courses
    ...SQL_COURSES.map(course => normalizeCourse(course, 'sql')),
    
    // SQL Phase 1 Courses
    ...SQL_PHASE1_COURSES.map(course => normalizeCourse(course, 'sql')),
    
    // SQL Advanced Phase Courses (Phase 2-6)
    ...SQL_ADVANCED_PHASE_COURSES.map(course => normalizeCourse(course, 'sql')),
    
    // Python Courses
    ...PYTHON_COURSES.map(course => normalizeCourse(course, 'python')),
    
    // AI Courses
    ...AI_COURSES.map(course => normalizeCourse(course, 'ai')),
    
    // Java Courses
    ...JAVA_COURSES.map(course => normalizeCourse(course, 'java')),
    
    // .NET Courses
    ...DOTNET_COURSES.map(course => normalizeCourse(course, 'dotnet')),
    
    // C# Courses
    ...CSHARP_COURSES.map(course => normalizeCourse(course, 'csharp')),
    
    // React Courses
    ...REACT_COURSES.map(course => normalizeCourse(course, 'react')),
    
    // AWS Courses
    ...AWS_COURSES.map(course => normalizeCourse(course, 'aws')),
    
    // JavaScript Courses
    ...JAVASCRIPT_COURSES.map(course => normalizeCourse(course, 'javascript')),
    
    // ML Courses
    ...ML_COURSES.map(course => normalizeCourse(course, 'ml')),
    
    // Data Science Courses
    ...DATASCIENCE_COURSES.map(course => normalizeCourse(course, 'datascience')),
    
    // Data Engineering Courses
    ...DATAENGINEERING_COURSES.map(course => normalizeCourse(course, 'dataengineering')),
    
    // GCP Courses
    ...GCP_COURSES.map(course => normalizeCourse(course, 'gcp')),
    
    // Power BI Courses
    ...POWERBI_COURSES.map(course => normalizeCourse(course, 'powerbi')),
    
    // Tableau Courses
    ...TABLEAU_COURSES.map(course => normalizeCourse(course, 'tableau')),
    
    // DevOps Courses
    ...DEVOPS_COURSES.map(course => normalizeCourse(course, 'devops')),
    
    // Application Security Courses
    ...APPSEC_COURSES.map(course => normalizeCourse(course, 'appsec')),
    
    // Mobile Development Courses
    ...MOBILE_COURSES.map(course => normalizeCourse(course, 'mobile')),
    
    // Backend Development Courses
    ...BACKEND_COURSES.map(course => normalizeCourse(course, 'backend')),
    
    // Database Technology Courses  
    ...DATABASE_COURSES.map(course => normalizeCourse(course, 'database')),
    
    // Azure Courses
    ...AZURE_COURSES.map(course => normalizeCourse(course, 'azure')),
    
    // Security Courses
    ...SECURITY_COURSES.map(course => normalizeCourse(course, 'security')),
    
    // Blockchain Courses
    ...BLOCKCHAIN_COURSES.map(course => normalizeCourse(course, 'blockchain')),
    
    // Enterprise Training Courses
    ...ENTERPRISE_TRAINING_COURSES.map(course => normalizeCourse(course, 'enterprise-training')),
    
    // Professional Development Courses
    ...PROFESSIONAL_DEVELOPMENT_COURSES.map(course => normalizeCourse(course, 'professional-development')),
    
    // Game Development Courses
    normalizeCourse(UNITY_GAME_DEVELOPMENT, 'game-development'),
    normalizeCourse(UNREAL_GAME_DEVELOPMENT, 'game-development'),
    normalizeCourse(AR_VR_DEVELOPMENT, 'game-development'),
    normalizeCourse(DESKTOP_APPLICATION_DEVELOPMENT, 'game-development'),
    
    // UI/UX Design Courses
    ...UI_UX_COURSES.map(course => normalizeCourse(course, 'ui-ux')),
    
    // Graphics Programming Courses
    ...GRAPHICS_PROGRAMMING_COURSES.map(course => normalizeCourse(course, 'graphics')),
    
    // ETL Courses
    ...ETL_COURSES.map(course => normalizeCourse(course, 'etl')),
    
    // Rust Courses
    ...RUST_COURSES.map(course => normalizeCourse(course, 'rust')),
    
    // Modern Frontend Courses
    ...MODERN_FRONTEND_COURSES.map(course => normalizeCourse(course, 'modern-frontend')),
    
    // Kubernetes Mastery Courses
    ...KUBERNETES_MASTERY_COURSES.map(course => normalizeCourse(course, 'kubernetes-mastery')),
    
    // Edge Computing Courses
    ...EDGE_COMPUTING_COURSES.map(course => normalizeCourse(course, 'edge-computing')),
    
    // Cross Platform Courses
    ...CROSS_PLATFORM_COURSES.map(course => normalizeCourse(course, 'cross-platform')),
    
    // Green Tech Courses
    ...GREEN_TECH_COURSES.map(course => normalizeCourse(course, 'green-tech')),
    
    // No Code Courses
    ...NO_CODE_COURSES.map(course => normalizeCourse(course, 'no-code')),
    
    // Advanced API Courses
    ...ADVANCED_API_COURSES.map(course => normalizeCourse(course, 'advanced-api')),
  ];
  
  console.log(`✅ Loaded ${allCourses.length} courses total`);
  console.log('Course types distribution:', {
    sql: allCourses.filter(c => c.type === 'sql').length,
    python: allCourses.filter(c => c.type === 'python').length,
    ai: allCourses.filter(c => c.type === 'ai').length,
    java: allCourses.filter(c => c.type === 'java').length,
    dotnet: allCourses.filter(c => c.type === 'dotnet').length,
    react: allCourses.filter(c => c.type === 'react').length,
    aws: allCourses.filter(c => c.type === 'aws').length,
    javascript: allCourses.filter(c => c.type === 'javascript').length,
    ml: allCourses.filter(c => c.type === 'ml').length,
    datascience: allCourses.filter(c => c.type === 'datascience').length,
    dataengineering: allCourses.filter(c => c.type === 'dataengineering').length,
    gcp: allCourses.filter(c => c.type === 'gcp').length,
    powerbi: allCourses.filter(c => c.type === 'powerbi').length,
    tableau: allCourses.filter(c => c.type === 'tableau').length,
    devops: allCourses.filter(c => c.type === 'devops').length,
    appsec: allCourses.filter(c => c.type === 'appsec').length,
    mobile: allCourses.filter(c => c.type === 'mobile').length,
    backend: allCourses.filter(c => c.type === 'backend').length,
    database: allCourses.filter(c => c.type === 'database').length,
    azure: allCourses.filter(c => c.type === 'azure').length,
    security: allCourses.filter(c => c.type === 'security').length,
    blockchain: allCourses.filter(c => c.type === 'blockchain').length,
    enterpriseTraining: allCourses.filter(c => c.type === 'enterprise-training').length,
    professionalDevelopment: allCourses.filter(c => c.type === 'professional-development').length,
  });
  
  return allCourses;
};

export const getAllCourseOverviews = (): CourseOverview[] => {
  const courses = getAllCourses();
  return courses.map(course => ({
    id: course.id,
    title: course.title,
    description: course.description,
    level: course.level,
    totalDuration: course.totalDuration,
    image: course.image,
    prerequisites: course.prerequisites,
    learningOutcomes: course.learningOutcomes,
    type: course.type as 'sql' | 'python' | 'ai' | 'java' | 'dotnet' | 'csharp' | 'react' | 'aws' | 'javascript' | 'ml' | 'datascience' | 'dataengineering' | 'gcp' | 'powerbi' | 'tableau' | 'azure' | 'devops' | 'appsec' | 'mobile' | 'backend' | 'database' | 'security' | 'blockchain' | 'enterprise-training' | 'professional-development' | 'game-development' | 'ui-ux' | 'graphics' | 'etl' | 'rust' | 'modern-frontend' | 'kubernetes-mastery' | 'edge-computing' | 'cross-platform' | 'green-tech' | 'no-code' | 'advanced-api',
  }));
};

export const COURSES = getAllCourses();

export const getCourseById = (courseId: string): Course | undefined => {
  const allCourses = getAllCourses();
  const course = allCourses.find(course => course.id === courseId);
  console.log('getCourseById:', courseId, 'found:', !!course);
  return course;
};
